import axios from "axios";
import {
    fpoBroadcastsUrl, fpoBroadcastDetailUrl, fpoBroadcastRecipientsUrl,
} from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /fpo/broadcasts/ — list broadcasts for the caller's FPO.
 * Params: search (matches broadcast number), channel, audience_type, page, page_size.
 */
export const getFPOBroadcasts = async (params = {}) => {
    const response = await axios.get(fpoBroadcastsUrl, { ...authHeaders(), params });
    return response;
};

/**
 * GET /fpo/broadcasts/<id>/ — broadcast detail (adds message_body, created_by).
 */
export const getFPOBroadcast = async (id) => {
    const response = await axios.get(fpoBroadcastDetailUrl(id), authHeaders());
    return response;
};

/**
 * GET /fpo/broadcasts/<id>/recipients/ — paginated recipients for a broadcast.
 * Params: search (name/mobile), status (pending/sent/failed), page, page_size.
 */
export const getFPOBroadcastRecipients = async (id, params = {}) => {
    const response = await axios.get(fpoBroadcastRecipientsUrl(id), { ...authHeaders(), params });
    return response;
};

/**
 * POST /fpo/broadcasts/ — create a broadcast (fpo_admin only). Resolves the
 * audience and records pending recipients — actual sending isn't wired up yet.
 */
export const addFPOBroadcast = async (data) => {
    const response = await axios.post(fpoBroadcastsUrl, data, authHeaders());
    return response;
};
